'use strict';


app.factory('Braintree', ['$rootScope', '$http', 'env_config',
    function ($rootScope, $http, env_config) {
        var service = {};


        /**
         * get new token method
         * 
         * @return String
         */
        service.getToken = function(callback){

            if( typeof $rootScope.braintree == 'undefined' || typeof $rootScope.braintree.token == 'undefined' ){
                // Card #806: Multi-Currency / Multi-Gateway Feature
                $http.get(env_config.waavepg_url + 'api/v1/users/' + $rootScope.globals.currentUser.id + '/pre-registration')
                    .success(function (resp, status) {
                        var token;
                        for (let i = 0; i < resp.data.length; i++) {
                            if(resp.data[i].name === 'braintree') {
                                token = resp.data[i].data[0].value;
                            }
                        }
                        callback(token, status);
                    })
                    .error(function(resp, status) {
                        callback(resp, status);
                    });
                // End card #806: Multi-Currency / Multi-Gateway Feature
            }
            else{
                callback($rootScope.braintree.token, 200);
            }
        }


        return service;
    }]);